<template>
  <li :class="wrapperClass" v-on="$listeners">
    <span v-if="disabled">{{ dayText }}</span>
    <a
      v-else-if="!invalidDay"
      href="javascript:void(0)"
      @click.prevent="dayClicked(date)"
    >
      {{ dayText }}
    </a>
  </li>
</template>

<script>
import isSameDay from 'date-fns/isSameDay'
export default {
  name: 'Day',
  props: {
    date: {
      type: Date,
      required: false,
      default: undefined,
    },
    dayNumber: {
      type: Number,
      required: true,
    },
    minEnableDate: {
      type: Date,
      required: true,
    },
    maxEnableDate: {
      type: Date,
      required: true,
    },
    startingDate: {
      type: Date,
      default: null,
    },
    endingDate: {
      type: Date,
      default: null,
    },
    hoveringDate: {
      type: Date,
      default: null,
    },
    range: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    invalidDay() {
      return this.dayNumber === -1
    },
    dayText() {
      return this.invalidDay ? ' ' : this.dayNumber
    },
    disabled() {
      // disable if before min date or after max date
      return (
        !this.invalidDay &&
        (this.date < this.minEnableDate || this.date > this.maxEnableDate)
      )
    },
    wrapperClass() {
      const cls = this.disabled || this.invalidDay ? 'disable ' : ''
      // selected
      if (isSameDay(this.startingDate, this.date)) {
        return cls + 'select checkIn'
      }
      if (this.range && isSameDay(this.endingDate, this.date)) {
        return cls + 'select checkOut'
      }
      if (this.range) {
        if (
          // between selected days
          (this.startingDate !== null &&
            this.endingDate !== null &&
            this.date > this.startingDate &&
            this.date < this.endingDate) || // hovered
          (this.startingDate !== null &&
            this.endingDate === null &&
            this.date > this.startingDate &&
            this.date <= this.hoveringDate)
        ) {
          return cls + 'select'
        }
      }
      return cls
    },
  },
  methods: {
    dayClicked() {
      this.$emit('day-clicked', { date: this.date })
    },
  },
}
</script>

<style lang="scss" scoped>
.hotelCalendarSlide ul li a {
  display: grid;
  place-items: center center;
  width: 100%;
  height: 100%;
  color: black;
}
.hotelCalendarSlide ul .checkIn a,
.hotelCalendarSlide ul .checkOut a {
  color: white;
  font-weight: bold;
}
</style>
